export default "__VITE_ASSET__CUZqfsa6__"